import { useTranslation } from 'react-i18next'

import type { ReactNode } from 'react'
import type { DeviceWarning } from './deviceWarning'

import styles from './medentee.module.css'

export type ToolbarButtonProps = {
  label: string
  icon: ReactNode
  isOn?: boolean
  isHangup?: boolean
  warning?: DeviceWarning
  onClick: () => void
  extraClassName?: string
}

export function ToolbarButton({
  label,
  icon,
  isOn,
  isHangup,
  warning,
  onClick,
  extraClassName
}: ToolbarButtonProps) {
  const { t } = useTranslation()

  const base = isHangup
    ? [styles.toolbarButton, styles.hangupButton]
    : [
        styles.toolbarButton,
        isOn ? styles.toolbarButtonActive : '',
        warning ? styles.toolbarButtonWarning : ''
      ]
  const className = [...base, extraClassName].filter(Boolean).join(' ')

  const warningMessage = warning && t(warning.messageKey)

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      disabled={!isHangup && !!warning?.isBlocking}
      aria-label={
        warningMessage ? t('chat.call.labelWithWarning', { label, warning: warningMessage }) : label
      }
      title={warningMessage ?? label}
    >
      {icon}
      {!!warning && (
        <span className={styles.warningBadge} aria-hidden>
          !
        </span>
      )}
    </button>
  )
}
